import { useQuery } from "@tanstack/react-query";
import type { City } from "../../../api/client/types/city.types";
import type { ApiError } from "../../../api/client/types/common.types";
import { cityEndpoints } from "../../../api/endpoints/city";

/**
 * React Query Keys
 * Organized keys help with cache invalidation and devtools debugging.
 */
const cityQueryKeys = {
  root: ["cities"] as const,
  list: () => [...cityQueryKeys.root, "list"] as const,
  detail: (id: number) => [...cityQueryKeys.root, "detail", id] as const,
};

/**
 * Hook: useGetCities
 * Fetches all cities.
 */
export const useGetCities = () => {
  return useQuery<City[], ApiError>({
    queryKey: cityQueryKeys.list(),
    queryFn: () => cityEndpoints.getAllCities(),
  });
};

/**
 * Hook: useGetCityById
 * Fetches a single city by ID.
 */
export const useGetCityById = (id: number) => {
  return useQuery<City, ApiError>({
    queryKey: cityQueryKeys.detail(id),
    queryFn: () => cityEndpoints.getCityById(id),
    enabled: !!id, // Only run if id is provided
  });
};

